import React from 'react';
import { testIdConcat } from '@atlassian/jira-navigation-apps-common/src/utils/test-id.tsx';
import { MenuItem as MenuItemCommon } from '../../../../../common/ui/menu/item/index.tsx';
import type { MenuItemProps } from './types.tsx';

export const MenuItem = ({ id, url, title, isVisible, onClick, testIdPrefix }: MenuItemProps) =>
	isVisible ? (
		<MenuItemCommon
			analytics={{
				actionSubjectId: 'plansNavigationMenuItem',
				menuItemId: id,
				menuItemType: 'action',
			}}
			href={url}
			key={id}
			onClick={onClick}
			testId={testIdConcat(testIdPrefix, `item-${id}`)}
		>
			{title}
		</MenuItemCommon>
	) : null;
